var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{staticStyle:{"margin":"auto","max-width":"500px","padding":"10px","margin-top":"10%"},attrs:{"src":_vm.image}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('h1',[_vm._v("404 Page Not Found")])])
}]

export { render, staticRenderFns }